import { Link } from "react-router-dom";

import { ExternalLink } from "lucide-react";

import { Button } from "~/components/ui/button";

interface SalesRequestLinkProps {
  id: string;
}

export const SalesRequestLink = ({ id }: SalesRequestLinkProps) => {
  return (
    <Button
      asChild
      variant="link"
      size="sm"
      className="h-auto p-0 text-blue-500 hover:text-blue-700"
    >
      <Link to={`/purchase-orders/${id}`}>
        <span className="inline-block max-w-[120px] truncate align-bottom">
          {id.substring(0, 8)}...
        </span>
        <ExternalLink className="ml-1 inline h-3 w-3" />
      </Link>
    </Button>
  );
};
